// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: tournament/payload/TournamentPayloadPt.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ApiResultPayload } from "../../common/model/ApiResultCodePt";
import { PagingRequestPayload, PagingResponsePayload } from "../../common/model/PagingPt";
import { TournamentPayload, TournamentSearchConditionPayload, TournamentSummaryPayload } from "../model/TournamentPt";

export const protobufPackage = "io.teamsillim.fightbracket.idl.tournament.payload";

export interface TournamentGetByIdRequestPayload {
  /** 고유 id */
  id: string;
}

export interface TournamentGetByIdResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 응답 */
  data: TournamentPayload | undefined;
}

/**
 * 대회 목록 요청
 *
 * 공개 목록은 취소된 대회를 빼고 내려주고, 관리자 목록은 상태 필터를 그대로 따른다.
 */
export interface TournamentGetByPagingRequestPayload {
  /** paging */
  paging:
    | PagingRequestPayload
    | undefined;
  /** 검색 조건 */
  search: TournamentSearchConditionPayload | undefined;
}

export interface TournamentGetByPagingResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 응답 */
  data: TournamentSummaryPayload[];
  /** paging */
  paging: PagingResponsePayload | undefined;
}

/**
 * 대회 등록 · 수정 (id 가 비어 있으면 등록이다)
 *
 * 주체는 토큰에서 읽는다 — 요청에 담긴 유저 정보는 신뢰하지 않는다.
 */
export interface TournamentSaveRequestPayload {
  /** 저장 대상 */
  data: TournamentPayload | undefined;
}

export interface TournamentSaveResponsePayload {
  /** 결과 */
  result:
    | ApiResultPayload
    | undefined;
  /** 저장된 대회 id */
  id: string;
}

/** 대회 삭제 (대회 · 신청 · 대진을 통째로 지운다 — 되돌릴 수 없다) */
export interface TournamentRemoveRequestPayload {
  /** 고유 id */
  id: string;
}

function createBaseTournamentGetByIdRequestPayload(): TournamentGetByIdRequestPayload {
  return { id: "" };
}

export const TournamentGetByIdRequestPayload: MessageFns<TournamentGetByIdRequestPayload> = {
  encode(message: TournamentGetByIdRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TournamentGetByIdRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTournamentGetByIdRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TournamentGetByIdRequestPayload {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: TournamentGetByIdRequestPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TournamentGetByIdRequestPayload>, I>>(base?: I): TournamentGetByIdRequestPayload {
    return TournamentGetByIdRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TournamentGetByIdRequestPayload>, I>>(
    object: I,
  ): TournamentGetByIdRequestPayload {
    const message = createBaseTournamentGetByIdRequestPayload();
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseTournamentGetByIdResponsePayload(): TournamentGetByIdResponsePayload {
  return { result: undefined, data: undefined };
}

export const TournamentGetByIdResponsePayload: MessageFns<TournamentGetByIdResponsePayload> = {
  encode(message: TournamentGetByIdResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.data !== undefined) {
      TournamentPayload.encode(message.data, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TournamentGetByIdResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTournamentGetByIdResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data = TournamentPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TournamentGetByIdResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: isSet(object.data) ? TournamentPayload.fromJSON(object.data) : undefined,
    };
  },

  toJSON(message: TournamentGetByIdResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data !== undefined) {
      obj.data = TournamentPayload.toJSON(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TournamentGetByIdResponsePayload>, I>>(
    base?: I,
  ): TournamentGetByIdResponsePayload {
    return TournamentGetByIdResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TournamentGetByIdResponsePayload>, I>>(
    object: I,
  ): TournamentGetByIdResponsePayload {
    const message = createBaseTournamentGetByIdResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = (object.data !== undefined && object.data !== null)
      ? TournamentPayload.fromPartial(object.data)
      : undefined;
    return message;
  },
};

function createBaseTournamentGetByPagingRequestPayload(): TournamentGetByPagingRequestPayload {
  return { paging: undefined, search: undefined };
}

export const TournamentGetByPagingRequestPayload: MessageFns<TournamentGetByPagingRequestPayload> = {
  encode(message: TournamentGetByPagingRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.paging !== undefined) {
      PagingRequestPayload.encode(message.paging, writer.uint32(10).fork()).join();
    }
    if (message.search !== undefined) {
      TournamentSearchConditionPayload.encode(message.search, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TournamentGetByPagingRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTournamentGetByPagingRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.paging = PagingRequestPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.search = TournamentSearchConditionPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TournamentGetByPagingRequestPayload {
    return {
      paging: isSet(object.paging) ? PagingRequestPayload.fromJSON(object.paging) : undefined,
      search: isSet(object.search) ? TournamentSearchConditionPayload.fromJSON(object.search) : undefined,
    };
  },

  toJSON(message: TournamentGetByPagingRequestPayload): unknown {
    const obj: any = {};
    if (message.paging !== undefined) {
      obj.paging = PagingRequestPayload.toJSON(message.paging);
    }
    if (message.search !== undefined) {
      obj.search = TournamentSearchConditionPayload.toJSON(message.search);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TournamentGetByPagingRequestPayload>, I>>(
    base?: I,
  ): TournamentGetByPagingRequestPayload {
    return TournamentGetByPagingRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TournamentGetByPagingRequestPayload>, I>>(
    object: I,
  ): TournamentGetByPagingRequestPayload {
    const message = createBaseTournamentGetByPagingRequestPayload();
    message.paging = (object.paging !== undefined && object.paging !== null)
      ? PagingRequestPayload.fromPartial(object.paging)
      : undefined;
    message.search = (object.search !== undefined && object.search !== null)
      ? TournamentSearchConditionPayload.fromPartial(object.search)
      : undefined;
    return message;
  },
};

function createBaseTournamentGetByPagingResponsePayload(): TournamentGetByPagingResponsePayload {
  return { result: undefined, data: [], paging: undefined };
}

export const TournamentGetByPagingResponsePayload: MessageFns<TournamentGetByPagingResponsePayload> = {
  encode(message: TournamentGetByPagingResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    for (const v of message.data) {
      TournamentSummaryPayload.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.paging !== undefined) {
      PagingResponsePayload.encode(message.paging, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TournamentGetByPagingResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTournamentGetByPagingResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.data.push(TournamentSummaryPayload.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.paging = PagingResponsePayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TournamentGetByPagingResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      data: globalThis.Array.isArray(object?.data)
        ? object.data.map((e: any) => TournamentSummaryPayload.fromJSON(e))
        : [],
      paging: isSet(object.paging) ? PagingResponsePayload.fromJSON(object.paging) : undefined,
    };
  },

  toJSON(message: TournamentGetByPagingResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.data?.length) {
      obj.data = message.data.map((e) => TournamentSummaryPayload.toJSON(e));
    }
    if (message.paging !== undefined) {
      obj.paging = PagingResponsePayload.toJSON(message.paging);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TournamentGetByPagingResponsePayload>, I>>(
    base?: I,
  ): TournamentGetByPagingResponsePayload {
    return TournamentGetByPagingResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TournamentGetByPagingResponsePayload>, I>>(
    object: I,
  ): TournamentGetByPagingResponsePayload {
    const message = createBaseTournamentGetByPagingResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.data = object.data?.map((e) => TournamentSummaryPayload.fromPartial(e)) || [];
    message.paging = (object.paging !== undefined && object.paging !== null)
      ? PagingResponsePayload.fromPartial(object.paging)
      : undefined;
    return message;
  },
};

function createBaseTournamentSaveRequestPayload(): TournamentSaveRequestPayload {
  return { data: undefined };
}

export const TournamentSaveRequestPayload: MessageFns<TournamentSaveRequestPayload> = {
  encode(message: TournamentSaveRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.data !== undefined) {
      TournamentPayload.encode(message.data, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TournamentSaveRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTournamentSaveRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.data = TournamentPayload.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TournamentSaveRequestPayload {
    return { data: isSet(object.data) ? TournamentPayload.fromJSON(object.data) : undefined };
  },

  toJSON(message: TournamentSaveRequestPayload): unknown {
    const obj: any = {};
    if (message.data !== undefined) {
      obj.data = TournamentPayload.toJSON(message.data);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TournamentSaveRequestPayload>, I>>(base?: I): TournamentSaveRequestPayload {
    return TournamentSaveRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TournamentSaveRequestPayload>, I>>(object: I): TournamentSaveRequestPayload {
    const message = createBaseTournamentSaveRequestPayload();
    message.data = (object.data !== undefined && object.data !== null)
      ? TournamentPayload.fromPartial(object.data)
      : undefined;
    return message;
  },
};

function createBaseTournamentSaveResponsePayload(): TournamentSaveResponsePayload {
  return { result: undefined, id: "" };
}

export const TournamentSaveResponsePayload: MessageFns<TournamentSaveResponsePayload> = {
  encode(message: TournamentSaveResponsePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.result !== undefined) {
      ApiResultPayload.encode(message.result, writer.uint32(10).fork()).join();
    }
    if (message.id !== "") {
      writer.uint32(18).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TournamentSaveResponsePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTournamentSaveResponsePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.result = ApiResultPayload.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TournamentSaveResponsePayload {
    return {
      result: isSet(object.result) ? ApiResultPayload.fromJSON(object.result) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : "",
    };
  },

  toJSON(message: TournamentSaveResponsePayload): unknown {
    const obj: any = {};
    if (message.result !== undefined) {
      obj.result = ApiResultPayload.toJSON(message.result);
    }
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TournamentSaveResponsePayload>, I>>(base?: I): TournamentSaveResponsePayload {
    return TournamentSaveResponsePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TournamentSaveResponsePayload>, I>>(
    object: I,
  ): TournamentSaveResponsePayload {
    const message = createBaseTournamentSaveResponsePayload();
    message.result = (object.result !== undefined && object.result !== null)
      ? ApiResultPayload.fromPartial(object.result)
      : undefined;
    message.id = object.id ?? "";
    return message;
  },
};

function createBaseTournamentRemoveRequestPayload(): TournamentRemoveRequestPayload {
  return { id: "" };
}

export const TournamentRemoveRequestPayload: MessageFns<TournamentRemoveRequestPayload> = {
  encode(message: TournamentRemoveRequestPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TournamentRemoveRequestPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTournamentRemoveRequestPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TournamentRemoveRequestPayload {
    return { id: isSet(object.id) ? globalThis.String(object.id) : "" };
  },

  toJSON(message: TournamentRemoveRequestPayload): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TournamentRemoveRequestPayload>, I>>(base?: I): TournamentRemoveRequestPayload {
    return TournamentRemoveRequestPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TournamentRemoveRequestPayload>, I>>(
    object: I,
  ): TournamentRemoveRequestPayload {
    const message = createBaseTournamentRemoveRequestPayload();
    message.id = object.id ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
